import './related.scss';

export default () => {

};
